<template>
  <div>
    <div class="modal_header">
      <el-row>
        <el-col :xs="24" :sm="24">
          <div class="grid-content bg-purple">
            <div class="title_h">
              <h5>{{ $t("message.services") }}</h5>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24">
          <div class="grid-content bg-purple-light">
            <el-row class="button_r">
              <export-excel
                  class="btn excel_btn"
                  :data="services"
                  :fields="excel_fields"
                  @fetch="controlExcelData()"
                  worksheet="Отчет-врачи"
                  :name="`Услуги.xls`"
              >
                <el-button icon="el-icon-document-delete"> Excel </el-button>
              </export-excel>
              <el-button class="pb-2" @click="resetForm()">{{
                  $t("message.close")
                }}</el-button>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="modal-doctoe-info" v-loading="loadingData">
      <el-row :gutter="10" class="credit_row">
        <el-col :span="8">
          <div class="font__W">{{ $t("message.patient_amount") }}</div>
          <div>
            {{ statistics.patients_count }}
          </div>
        </el-col>
        <el-col :span="8">
          <div class="font__W">{{ $t("message.orders_count") }}</div>
          <div>
            {{ statistics.orders_count }}
          </div>
        </el-col>
        <el-col :span="8">
          <div class="font__W">{{ $t("message.total_price") }}</div>
          <div>{{ statistics.total_price | formatMoney }}</div>
        </el-col>
      </el-row>

      <div class="text-center float-left sorddata my-3">
        <el-date-picker
            size="mini"
            v-model="filterForm.start_date"
            type="date"
            :format="'dd.MM.yyyy'"
            :value-format="'dd.MM.yyyy'"
            :placeholder="$t('message.start_date')"
        ></el-date-picker>
        <el-date-picker
            size="mini"
            v-model="filterForm.end_date"
            type="date"
            :format="'dd.MM.yyyy'"
            :value-format="'dd.MM.yyyy'"
            :placeholder="$t('message.end_date')"
        ></el-date-picker>
      </div>
      <table
          class="table table-hover table-bordered mt-3 table__cerditne__forma"
          v-loading="loadingData"
      >
        <crm-pagination
            :pagination="pagination"
            @c-change="updatePagination"
        />

        <el-dialog
            :title="$t('message.pay')"
            :visible.sync="dialogVisible"
            width="30%"
            :append-to-body="true"
        >
          <el-select
            v-model="payment_type_id"
            filterable
            :placeholder="$t('message.payment_type')"
          >
            <el-option
              v-for="item in paymentTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-dialog>
        <template >
          <thead>
          <tr>
            <th scope="col">id</th>
            <th scope="col">{{ $t("message.patient") }}</th>
            <th scope="col">{{ $t("message.service") }}</th>
            <th scope="col">{{ $t("message.amount") }}</th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(service, index) in services" :key="index">
              <td>{{ service.order_id + '-' + service.service_id }}</td>
              <td>{{ service.patient_name }}</td>
              <td>{{ service.service_name }}</td>
              <td>{{ service.order_total_price | formatMoney }}</td>
            </tr>
          </tbody>
        </template>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import form from "@/utils/mixins/form";
import {i18n} from "@/utils/i18n";
import {formatMoney} from "@/filters";
export default {
  mixins: [form],
  props: ["selected"],
  data() {
    return {
      filterForm: {
        start_date: "",
        end_date: "",
      },
      loadingData: false,
      excel_fields: {},
      payment_type_id: null,
      page: 1,
      per_page: 10,
      dialogVisible: false,
      checkedOrders: [],
    };
  },
  computed: {
    ...mapGetters({
      services: "patientResidenceReport/services",
      statistics: "patientResidenceReport/statistics",
      reports: "patientResidenceReport/reports",
      columns: "patientResidenceReport/columns",
      paymentTypes: "paymentTypes/list",
      pagination: "patientResidenceReport/pagination",
    }),
    paid_bonus: function () {
      let orders = this.form;
      let prices = 0;
      if (orders) {
        for (let i = 0; i < orders.length; i++) {
          const element = orders[i];

          prices += parseFloat(element.paid_amount);
        }
      }
      return prices;
    },
    total_bonus: function () {
      let orders = this.form;
      let prices = 0;
      if (orders) {
        for (let i = 0; i < orders.length; i++) {
          const element = orders[i];

          prices += parseFloat(element.bonus_amount);
        }
      }
      return prices;
    },
  },
  async created() {},
  async mounted() {
    this.controlExcelData();
    this.paymentTypesList();
  },
  watch: {
    "pagination.page": {
      handler: async function (newVal, oldVal) {
        await this.showReport();
      },
    },
    "pagination.per_page": {
      handler: async function (newVal, oldVal) {
        await this.showReport();
      },
    },
    columns: {
      handler: function () {
        this.controlExcelData();
      },
      deep: true,
    },
    filterForm: {
      handler: function (newVal, oldVal) {
        this.showReport();
      },
      deep: true,
    },
    model: {
      handler: function (newVal, oldVal) {},
      deep: true,
    },
  },
  methods: {
    formatMoney,
    ...mapActions({
      updatePagination: "patientResidenceReport/updatePagination",
      showServices: "patientResidenceReport/show",
      paymentTypesList: "paymentTypes/index",
    }),
    colorPicker(item) {
      if (item !== null && item.bonus_amount == item.paid_amount) {
        return "background-color: rgb(171 255 168 / 62%)";
      } else {
        return "background-color: #ffffff";
      }
    },
    openDialog() {
      this.payment_type_id = null;
      this.dialogVisible = true;
    },
    showReport() {
      this.loadingData = true;
      const query = {
        ...this.filter,
        ...this.pagination,
        ...this.sort,
        ...this.selected,
        start_date: this.filterForm.start_date,
        end_date: this.filterForm.end_date,
      };
      this.showServices(query)
        .then((res) => {
          this.loadingData = false;
        })
        .catch((err) => {
          this.loadingData = false;
        });
    },
    afterOpen() {
      this.loadingData = true;
      const query = {
        ...this.filter,
        ...this.pagination,
        ...this.sort,
        ...this.selected,
        start_date: this.filterForm.start_date,
        end_date: this.filterForm.end_date,
      };
      this.showServices(query)
        .then((res) => {
          this.loadingData = false;
        })
        .catch((err) => {
          this.loadingData = false;
        });
    },
    controlExcelData() {
      this.excel_fields = {
        id: {
          fields: [],
          callback: (value) => {
            return value.order_id + '-' + value.service_id;
          },
        },
        "Пациент": "patient_name",
        "Услуга": "service_name",
        "Сумма": "order_total_price",
      };
    },
    resetForm() {
      this.$emit("c-close", { drawer: "drawer" });
    },
    id(model) {
      let id;
      if (model.order_service) id = model.order_service ? model.order_service.order_id : "";
      if (model.hospitalization_service) id = model.hospitalization_service ? model.hospitalization_service.patient_history_id : "";
      return id;
    },
    type(model) {
      if (model.order_service) return i18n.t('message.ambulatory');
      if (model.hospitalization_service) return i18n.t('message.stationary');
    },
  },
};
</script>
<style lang="scss">
.modal-doctoe-info {
  margin: 20px 30px;
}
.dark-mode .filter-wrap__btn.active {
  border-color: #4580eb !important;
  background-color: #4580eb !important;
}

.filter-wrap {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 16px;
  @media screen and (max-width: 1168px) {
    gap: 1rem;
    flex-wrap: wrap;
  }

  // filter-wrap__btn
  &__btn {
    outline: none;
    background: #e4e2e4;
    border: none;
    border-radius: 10px;
    padding: 6px 20px;
    color: #606266;
    font-weight: 600;
    font-size: 15px;
    transition: all 0.15s ease-in-out;

    &.active {
      color: #e4e2e4;
      background: #409eff;
    }

    &::first-letter {
      text-transform: uppercase;
    }

    &:hover {
      color: #e4e2e4;
      background: #66b1ff;
    }

    &:active {
      background: #3a8ee6;
    }
  }
}
.credit_row {
  margin-left: 10px;
  margin-right: -10px;
  text-align: center;
  background-color: #e4e7ed;
  padding: 10px 0;
  .font__W {
    font-weight: 600;
    font-size: 15px;
  }
  .color_or {
    background: #ffbb58;
    color: #fff;
    padding: 2px 7px;
    border-radius: 10px;
  }
  div {
    font-size: 14px;
  }
}
.act_color {
  background-color: #67c23a;
  color: #fff;
  padding: 2px 7px;
  border-radius: 10px;
}
.not-paid {
  border: 1px solid #dee2e6;
  padding: 1px 4px;
  border-radius: 10px;
  background-color: #fff;
}
.watch--story {
  padding: 7px 8px;
  background-color: #409eff;
  color: #fff;
}
.table__cerditne__forma {
  th {
    font-weight: 600 !important;
    color: #303030 !important;
    font-size: 14px !important;
  }
  th,
  td {
    padding: 0.55rem !important;
  }
  .action_tr {
    background: #ffbb58;
  }
}
</style>